import { render, staticRenderFns } from "./SchemeReview.vue?vue&type=template&id=e7671b86&"
import script from "./SchemeReview.vue?vue&type=script&lang=js&"
export * from "./SchemeReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports